import { translationLivechat_en_part1 } from "./translationLivechat.en.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationLivechat_en_part2 } from "./translationLivechat.en.part2";
import { translationLivechat_en_part3 } from "./translationLivechat.en.part3";
import { translationLivechat_en_availability } from "./translationLivechat.en.availability";
import { translationLivechat_en_autoClose } from "./translationLivechat.en.autoClose";
import { translationLivechat_en_case } from "./translationLivechat.en.case";
import { translationLivechat_en_edit } from "./translationLivechat.en.edit";
import { translationLivechat_en_header } from "./translationLivechat.en.header";
import { translationLivechat_en_schedules } from "./translationLivechat.en.schedules";

export const translationLivechat_en = defineTranslationTree({
  ...translationLivechat_en_availability,
  ...translationLivechat_en_autoClose,
  ...translationLivechat_en_case,
  ...translationLivechat_en_edit,
  ...translationLivechat_en_header,
  ...translationLivechat_en_schedules,
  ...translationLivechat_en_part1,
  ...translationLivechat_en_part2,
  ...translationLivechat_en_part3,
});
